import users, {setCurrentUser} from "./users";
import {appContainer} from "../../contexts/app";
import {fromImmutable, toImmutable, setInState, setListInState, deleteInState, validate, validateEmail} from "../hooks";

export default app => {
  const service = app.service("api/users");
  // Lengthen the timeout to allow for image uploads
  service.timeout = 10000;
  const UserRecord = users(service, appContainer);

  const validateUser = validate({
    first_name: "First name is required",
    last_name: "Last name is required",
    email: validateEmail
  });

  appContainer.UserRecord = UserRecord;
  app.set("UserRecord", UserRecord);

  service.hooks({
    before: {
      all: [],
      find: [],
      get: [],
      // create: [], we never create a user
      update: [fromImmutable, validateUser],
      patch: [fromImmutable, validateUser],
      remove: []
    },

    after: {
      all: [toImmutable(UserRecord)],
      find: [setListInState("users")],
      get: [setInState("users"), setCurrentUser],
      create: [setInState("users")],
      update: [setInState("users"), setCurrentUser],
      patch: [setInState("users"), setCurrentUser],
      remove: [deleteInState("users")]
    },

    error: {
      all: [],
      find: [],
      get: [],
      create: [],
      update: [],
      patch: [],
      remove: []
    }
  });
};



// WEBPACK FOOTER //
// ./src/feathers/users/users-setup.js